/**
 * Règles d'affichage RDV planning opérationnel Mon équipe.
 * Aligné sur les statuts qui bloquent réellement la ressource (L4 / hold).
 */

/** RDV visibles dans le planning opérationnel et comptés dans le badge jour. */
export const OPERATIONAL_RDV_STATUTS = new Set([
  'EN_ATTENTE',
  'EN_ATTENTE_PAIEMENT',
  'CONFIRME',
]);

/** RDV visibles en historique du jour passé uniquement (non comptés futur). */
export const HISTORICAL_RDV_STATUTS = new Set(['TERMINE', 'ABSENT']);

export const EXCLUDED_RDV_STATUTS = new Set(['ANNULE']);

export const RDV_STATUS_UX = {
  CONFIRME: { label: 'Confirmé', className: 'bg-blue-100 text-blue-800' },
  EN_ATTENTE: { label: 'En attente', className: 'bg-amber-100 text-amber-800' },
  EN_ATTENTE_PAIEMENT: { label: 'En attente paiement', className: 'bg-orange-100 text-orange-800' },
  TERMINE: { label: 'Terminé', className: 'bg-gray-100 text-gray-700' },
  ABSENT: { label: 'Client absent', className: 'bg-gray-100 text-gray-600' },
};

export function isOperationalRdv(rdv, { includeHistorical = false } = {}) {
  const statut = String(rdv?.statut || '').toUpperCase();
  if (EXCLUDED_RDV_STATUTS.has(statut)) return false;
  if (OPERATIONAL_RDV_STATUTS.has(statut)) return true;
  if (includeHistorical && HISTORICAL_RDV_STATUTS.has(statut)) return true;
  return false;
}

export function countOperationalRdvOnDay(rdvList, ymd) {
  return (rdvList || []).filter(
    (r) =>
      isOperationalRdv(r) &&
      new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris' }).format(
        new Date(r.dateDebut),
      ) === ymd,
  ).length;
}

export function filterWeekOperationalRdv(rdvList, weekDays) {
  const ymdSet = new Set(weekDays.map((d) => d.ymd));
  return (rdvList || [])
    .filter((r) => {
      if (!isOperationalRdv(r)) return false;
      const ymd = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris' }).format(
        new Date(r.dateDebut),
      );
      return ymdSet.has(ymd);
    })
    .sort((a, b) => new Date(a.dateDebut) - new Date(b.dateDebut));
}

/** Mappe un RDV API vers la shape commande attendue par RdvDetailContent. */
export function mapRdvToCommande(rdv, commercant) {
  if (!rdv) return null;
  return {
    ...rdv,
    type: 'RENDEZ_VOUS',
    numero: rdv.numero || (rdv.id ? `RDV-${String(rdv.id).toUpperCase()}` : undefined),
    commercant: commercant || rdv.commercant || null,
  };
}
